// API/rekapAnggaran.js
import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

// ============================================================
// 1. REKAP PER BANTUAN
// ============================================================

/**
 * Get rekap anggaran per bantuan
 * @param {Object} params - Filter parameters
 * @param {number} params.BantuanId - ID bantuan (opsional)
 * @param {number} params.tahun - Tahun (opsional)
 * @param {number} params.bulan - Bulan (opsional)
 * @param {number} params.page - Halaman (opsional)
 * @param {number} params.limit - Limit per halaman (opsional)
 */
export const getRekapPerBantuan = (params = {}) => {
  const { BantuanId, ...queryParams } = params;
  
  if (BantuanId) {
    return axios.get(`${BASE}/rekaptransaksi/bantuan/${BantuanId}`, {
      params: queryParams
    });
  }
  
  return axios.get(`${BASE}/rekaptransaksi/bantuan`, {
    params: queryParams
  });
};

// ============================================================
// 2. REKAP PER SUPPLIER
// ============================================================

/**
 * Get rekap anggaran per supplier
 * @param {Object} params - Filter parameters
 * @param {number} params.supplierId - ID supplier (opsional)
 * @param {string} params.startDate - Tanggal mulai (YYYY-MM-DD)
 * @param {string} params.endDate - Tanggal akhir (YYYY-MM-DD)
 * @param {number} params.page - Halaman (opsional)
 * @param {number} params.limit - Limit per halaman (opsional)
 */
export const getRekapPerSupplier = (params = {}) => {
  const { supplierId, ...queryParams } = params;
  
  if (supplierId) {
    return axios.get(`${BASE}/rekaptransaksi/supplier/${supplierId}`, {
      params: queryParams
    });
  }
  
  return axios.get(`${BASE}/rekaptransaksi/supplier`, {
    params: queryParams
  });
};

// ============================================================
// 3. REKAP PER JENIS BANTUAN
// ============================================================

/**
 * Get rekap anggaran per jenis bantuan
 * @param {Object} params - Filter parameters
 * @param {number} params.tahun - Tahun (opsional)
 */
export const getRekapPerJenis = (params = {}) => {
  return axios.get(`${BASE}/rekaptransaksi/jenis`, {
    params
  });
};

// ============================================================
// 4. REKAP PER PERIODE (BULANAN/TAHUNAN)
// ============================================================

/**
 * Get rekap anggaran per periode (bulanan/tahunan)
 * @param {Object} params - Filter parameters
 * @param {number} params.tahun - Tahun (opsional)
 * @param {number} params.bulan - Bulan (opsional)
 */
export const getRekapPeriode = (params = {}) => {
  return axios.get(`${BASE}/rekaptransaksi/periode`, {
    params
  });
};

// ============================================================
// 5. DETAIL ANGGARAN BANTUAN
// ============================================================

/**
 * Get detail anggaran bantuan lengkap dengan RAB
 * @param {number} BantuanId - ID Bantuan
 */
export const getDetailAnggaranBantuan = (BantuanId) => {
  return axios.get(`${BASE}/rekaptransaksi/detail/${BantuanId}`);
};

// ============================================================
// 6. EXPORT REKAP ANGGARAN
// ============================================================

/**
 * Export rekap anggaran ke CSV/Excel
 * @param {Object} params - Filter parameters
 * @param {string} params.format - Format export (csv/excel)
 * @param {number} params.tahun - Tahun (opsional)
 * @param {number} params.bulan - Bulan (opsional)
 * @param {string} params.startDate - Tanggal mulai (opsional)
 * @param {string} params.endDate - Tanggal akhir (opsional)
 */
export const exportRekapAnggaran = (params = {}) => {
  return axios.get(`${BASE}/rekaptransaksi/export`, {
    params,
    responseType: 'blob' // Untuk download file
  });
};

// ============================================================
// 7. DASHBOARD REKAP ANGGARAN (Ringkasan)
// ============================================================

/**
 * Get dashboard rekap anggaran
 * @param {Object} params - Filter parameters
 * @param {number} params.tahun - Tahun (opsional)
 */
export const getRekapDashboard = (params = {}) => {
  return axios.get(`${BASE}/rekaptransaksi/dashboard`, {
    params
  });
};

// ============================================================
// DEFAULT EXPORT
// ============================================================

export default {
  getRekapPerBantuan,
  getRekapPerSupplier,
  getRekapPerJenis,
  getRekapPeriode,
  getDetailAnggaranBantuan,
  exportRekapAnggaran,
  getRekapDashboard
};